var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"kook-btn",class:_vm.isLink ? '--clickable' : '--not-clickable',attrs:{"href":_vm.url,"target":_vm.blank ? '_blank' : ''},domProps:{"innerHTML":_vm._s(_vm.texte)}})
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/global/KookBtn.vue